import { render, staticRenderFns } from "./turbulence-statistics.vue?vue&type=template&id=f2839eb8&scoped=true"
import script from "./turbulence-statistics.vue?vue&type=script&lang=js"
export * from "./turbulence-statistics.vue?vue&type=script&lang=js"
import style0 from "./turbulence-statistics.vue?vue&type=style&index=0&id=f2839eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2839eb8",
  null
  
)

export default component.exports